import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var ValidationService = function ValidationService() {
  _classCallCheck(this, ValidationService);

  this.required = function (value) {
    return value || typeof value === 'number' ? undefined : 'Required';
  };

  this.minLength = function (minimumLength) {
    var customMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return function (value) {
      var message = customMessage !== '' ? customMessage : "Must be ".concat(minimumLength, " characters or more.");
      return value && value.length < minimumLength ? message : undefined;
    };
  };

  this.exactLength = function (exactLengthNums) {
    var customMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return function (value) {
      if (!value) {
        return undefined;
      }

      exactLengthNums = Array.isArray(exactLengthNums) ? exactLengthNums : Array.of(exactLengthNums);
      var exactLength = value.length && exactLengthNums.some(function (length) {
        return value.length === length;
      });
      return !exactLength ? customMessage : undefined;
    };
  };

  this.passwordsMatch = function (value, allValues) {
    return allValues.password !== allValues.confirmPassword ? 'Passwords must match' : undefined;
  };

  this.isInteger = function (value) {
    if (!value) {
      return undefined;
    }

    return value.match(/^\d+$/) ? undefined : 'Please enter a whole number';
  };

  this.isIntegerGreaterThenZero = function (value) {
    if (!value) {
      return undefined;
    }

    return value.match(/^[1-9][0-9]*$/) ? undefined : 'Please enter a number greater than 0';
  };

  this.percentageRange = function (value) {
    if (!value) {
      return undefined;
    }

    var intValueInRange = value.match(/^\d+$/) && value > 0 && value <= 100;
    var floatValueInRange = value.match(/^\d+(\.\d{1,2})?$/) && value > 0 && value <= 100.0;
    return intValueInRange || floatValueInRange ? undefined : 'Please enter a number between 0 and 100';
  };

  this.customTaxIdBrazilValidation = function (value) {
    return value.match(/^\d{14}$/) ? undefined : 'Must be a whole number = 14 digits.';
  };
};

export default new ValidationService();